import React, { useState } from "react";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Tooltip } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { API } from "../../api/api";

const hasValue = (field) =>
    (field?.value !== null && field?.value !== undefined && String(field.value).trim() !== "") ||
    (Array.isArray(field?.children) && field.children.some(hasValue));

// Anything entered or attached counts as filled, so deleting it needs a confirmation.
export const isTestFilled = (test) =>
    Boolean(test?.reportedAt || test?.fileMediaId || test?.customValue?.trim?.()) ||
    (Array.isArray(test?.values) && test.values.some(hasValue));

const DeleteTestButton = ({ test, onDeleted }) => {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const deleteTest = async () => {
        setDeleting(true);
        const response = await API.delete(`/v1/tests/${test.id}`);
        setDeleting(false);
        setConfirmOpen(false);
        if (!response?.success) {
            window.alert(response?.message || "Could not delete the test");
            return;
        }
        onDeleted();
    };

    if (deleting && !confirmOpen) return <CircularProgress size={18} />;

    return (
        <>
            <Tooltip title="Delete this test">
                <IconButton
                    aria-label={`Delete ${test.testName}`}
                    onClick={() => (isTestFilled(test) ? setConfirmOpen(true) : deleteTest())}
                    size="small"
                    sx={{ p: 0, width: 20, height: 20, ml: 1 }}
                >
                    <DeleteOutlineIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            <Dialog open={confirmOpen} onClose={() => !deleting && setConfirmOpen(false)}>
                <DialogTitle>Delete {test.testName}?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This test already has results entered. Deleting it removes it and its results from the patient's record.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)} disabled={deleting}>Cancel</Button>
                    <Button color="error" variant="contained" onClick={deleteTest} disabled={deleting}>
                        {deleting ? <CircularProgress size={18} color="inherit" /> : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DeleteTestButton;
